import { Component, OnInit } from '@angular/core';
import {Input} from '@angular/core';
import {NzDrawerRef} from 'ng-zorro-antd';
import {_HttpClient} from '@delon/theme';
import {NzMessageService} from 'ng-zorro-antd';
import {SystemContants} from '@core/constants';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-contract-editor',
  templateUrl: './contract-editor.component.html',
  styles: []
})
export class ContractEditorComponent implements OnInit {

  @Input()
  record: any = {};

  startTime: any = null;
  endTime: any = null;

  constructor(private ref: NzDrawerRef,
              private datePipe: DatePipe,
              private http:_HttpClient,
              private msg: NzMessageService) { }

  ngOnInit() {
    if (this.record != null) {
      if (this.record.startTime != null) {
        this.startTime = new Date(this.record.startTime);
      }
      if (this.record.endTime != null) {
        this.endTime = new Date(this.record.endTime);
      }
    }
  }

  onStartTimeChange(time: any) {
    this.record.startTime = this.datePipe.transform(time, "yyyy-MM-dd 00:00:00", "UTC+8");
  }

  onEndTimeChange(time: any) {
    this.record.endTime = this.datePipe.transform(time, "yyyy-MM-dd 00:00:00", "UTC+8");
  }

  toCancel() {
    this.ref.close();
  }

  toSave() {
    if (this.record.id == null) {
      this.http.post<any>('api/app/contract', this.record).subscribe((resp) => {
        if (resp.status === SystemContants.STATUS_SUCCESS) {
          this.ref.close(1);
        }
      })
    } else {
      this.http.put<any>('api/app/contract', this.record).subscribe((resp) => {
        if (resp.status === SystemContants.STATUS_SUCCESS) {
          this.ref.close(1);
        }
      })
    }
  }

}
